import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { roles } from '../constants';

const Roles = () => {
    return (
        <section id="roles" className="section">
            <div className="container">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="mb-16"
                >
                    <h2 className="text-4xl md:text-5xl font-bold mb-4">Leadership</h2>
                </motion.div>

                <div className="grid md:grid-cols-2 gap-8">
                    {roles.map((role, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, scale: 0.95 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.2, duration: 0.6 }}
                            className="glass-card p-8 border border-white/5 bg-gradient-to-br from-white/[0.02] to-transparent"
                        >
                            <div className="flex items-center gap-3 mb-6">
                                <Star size={24} className="text-secondary-blue" />
                                <span className="text-sm font-mono text-secondary-blue border border-secondary-blue/20 px-3 py-1 rounded-full">
                                    {role.duration}
                                </span>
                            </div>

                            <h3 className="text-2xl font-bold text-white mb-4">
                                {role.title}
                            </h3>

                            <p className="text-gray-400 leading-relaxed font-light">
                                {role.description}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Roles;
